import { UpdateStamp } from "./UpdateStamp"

export class LinkedPermits extends UpdateStamp {
    LinkedPermitId :number
    PermitId:Number
    ChildPermitId :Number
}